import {
    ActionService,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {inject, Injectable} from "@angular/core";
import {OrderPlacementStatus} from "./order-placement.service";

export class OrderPlacementStatusData extends EntityData<OrderPlacementStatusData> {
    @field status: OrderPlacementStatus;
    @field secondsElapsed: number;
    @field timeoutSecondsPhase1: number;
    @field timeoutSecondsPhase2: number;
}

@Injectable({providedIn: "root"})
export class OrderPlacementStatusService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- OrderPlacementStatusService");

        super(http, nameSpace, "app-order-placement-status", configService, useAsync, actionNames);
    }
}
